import React from "react";
import { Photography } from "../../search-advanced-filters/forms/photography";
import { ImageEditingQa } from "../../search-advanced-filters/forms/image-editing-qa";
import { NonAdminSearchForm } from "../../search-advanced-filters/forms/non-admin-search-form";
import { AdminSearchForm } from "../../search-advanced-filters/forms/admin-search-form";
import { FinalQaForm } from "../../search-advanced-filters/forms/final-qa-form";
import { ImageEditingForm } from "../../search-advanced-filters/forms/image-editing-form";

export const FORM_TYPE = {
    Photography: "photography",
    ImageEditingQa: "imageeditingqa",
    ImageEditing: "imageediting",
    Search: "search",
    AdminSearch: "admin-search",
    FinalQa: "finalqa",
};

export const FormSelector = ({ task }) => {
    switch (task) {
        case FORM_TYPE.Photography:
            return <Photography />;
        case FORM_TYPE.ImageEditingQa:
            return <ImageEditingQa />;
        case FORM_TYPE.ImageEditing:
            return <ImageEditingForm />;
        case FORM_TYPE.Search:
            return <NonAdminSearchForm />;
        case FORM_TYPE.AdminSearch:
            return <AdminSearchForm />;
        case FORM_TYPE.FinalQa:
            return <FinalQaForm />;
        default:
            return null;
    }
};
